import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {formatCurrency, handleDefaultValues} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {getInventoryEvent, getInventoryGiftCards, getInventoryMemberships} from "../../common/api/PortalCustomerApi";
import {Card, CardContent, Chip, Divider, Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import ViewInventoryModal from "../modal/ViewInventoryModal";
import {CartContext} from "../../../lib/CartProvider";
import MDTypography from "../../../components/MDTypography";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

export default function GiftCardsMiniPane(props) {
  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useState(CartContext);

  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [giftCards, setGiftCards] = useState([]);

  useEffect(() => {
    getInventoryFn()
  }, []);

  const [inventory, setInventory] = useState();
  const [showMembershipModal, setShowMembershipModal] = useState(false);
  const [savingMembership, setSavingMembership] = useState(false);
  const [inventoryType, setInventoryType] = useState();
  const [formInvalid, setFormInvalid] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const handleClose = () => {
    setShowMembershipModal(false);
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };

  const getInventoryFn = async () => {
    let result = await getInventoryGiftCards();
    setGiftCards(result);
  }

  const viewInventory = (e) => {
    setInventory(e);
    setShowMembershipModal(true);
  };

  const loadCartFn = () => {

    setCartContext({...cartContext, reloadCart: true, caller: 'inventory mini pane'})

    let _context = {...context};
    _context.toast = {
      message: 'Added to cart!',
      type: 'success'
    }
    setContext({..._context});
  };

  return (
    <>
      <MDBox>
        <Grid container cols={2} spacing={2} direction="row">
          <Grid item sm={12}>
            <Grid container spacing={2}>
              {giftCards?.length > 0 && <>
                {giftCards?.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
                  .map((inventory, index) => {
                    return (
                      <Grid item md={6} sm={6} xs={12} key={index}
                            className={'d-inline-grid'}>
                        <Card>
                          <CardContent>
                            <Grid container spacing={3}>
                              <Grid item xs={6} sm={2}>
                                <center>
                                  {inventory?.imageUrl ? <img
                                    className="img-thumbnail m-2"
                                    alt={inventory.name}
                                    src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                  /> : <>&nbsp;</>
                                  }
                                </center>
                              </Grid>
                              <Grid item xs={6} sm={10}>
                                <h3>
                                  {inventory.name}&nbsp;
                                </h3>
                                <h5>
                                  {inventory.accountType?.name}&nbsp;
                                </h5>
                                <h6>
                                  {inventory?.minAmount === inventory?.maxAmount && <>
                                    {formatCurrency(inventory?.minAmount)}&nbsp;
                                  </>}
                                  {inventory?.minAmount !== inventory?.maxAmount && <>
                                    {formatCurrency(inventory?.minAmount) + ' - ' + formatCurrency(inventory?.maxAmount)}&nbsp;
                                  </>}
                                </h6>
                                <p>
                                  {inventory.desc}
                                </p>
                                <MDBox mt={1}>
                                  <MDBox display="flex" className={'mt-2'} justifyContent="flex-end">
                                    <MDButton
                                      size={'small'}
                                      color="secondary"
                                      onClick={(e) => {
                                        viewInventory(inventory);
                                      }}>View Details</MDButton>
                                  </MDBox>
                                </MDBox>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    )
                  })
                }
              </>}
            </Grid>
          </Grid>
        </Grid>
      </MDBox>

      {
        inventory && <ViewInventoryModal
          key={inventory?.guid}
          handleClose={handleClose}
          handleSave={handleSave}
          membershipType={false}
          show={showMembershipModal}
          inventory={inventory}
        />
      }

    </>
  )
}